import { StageConfig } from './config';

// Please don't modify here but in your own .env (see .env.sample)
const stageConfig: StageConfig = {
    SHOWHOLIDAYHOURS: true,
};

export default stageConfig;
